import React from 'react';
import { AudioType } from '../../../../dorian-shared/types/audio/audio';
import { MusicActionSettings } from '../../../../dorian-shared/types/audio/AudioStepSettingsType';
import { AudioTrackPicker } from '../AudioTrackPicker/AudioTrackPicker';

export type AudioMusicSettingsProps = {
  value: MusicActionSettings;
  onChange: (value: MusicActionSettings) => void;
  focused?: boolean;
  disabled?: boolean;
};

export function AudioMusicSelect(props: AudioMusicSettingsProps) {
  const { value, onChange, disabled } = props;
  return (
    <AudioTrackPicker
      audioType={AudioType.Music}
      value={value}
      onChange={(next) => onChange(next as MusicActionSettings)}
      disabled={disabled}
      panelPlacement="up"
    />
  );
}
